<template>
  <div class="flex flex-col gap-20">
    <div v-if="!batches.results" class="flex justify-center items-center h-200">
      <SparkSpinner />
    </div>
    <div v-else-if="!group" class="flex flex-col items-center justify-center h-200 gap-16">
      <div class="text-18 font-medium text-gray-900">Group not found</div>
      <div class="text-14 text-gray-500">The requested group could not be found.</div>
      <SparkButton variant="secondary" @click="$router.push({ name: 'group' })"> Back to Groups </SparkButton>
    </div>
    <template v-else>
      <GroupDetailsTitle />
      <PartTable :filter-key="Number($route.params.id)" :show-title="false" />
    </template>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { mapState, mapActions } from 'vuex';
import PartTable from '@/components/PartLibrary/PartTable.vue';
import GroupDetailsTitle from './GroupDetailsTitle.vue';
import SparkSpinner from '@/components/SparkComponents/SparkSpinner.vue';
import SparkButton from '@/components/SparkComponents/SparkButton.vue';

interface Batch {
  batch_pk: number;
  batch_name: string;
  number_of_parts: number;
  created_by: string;
  created_at: string;
  prp_order_uid?: string;
  order_finalized?: boolean;
}

interface BatchesState {
  results: Batch[];
  count?: number;
  num_pages?: number;
  per_page?: number;
}

export default defineComponent({
  name: 'GroupDetails',

  components: { GroupDetailsTitle, PartTable, SparkSpinner, SparkButton },

  computed: {
    ...mapState(['batches']),

    group(): Batch | undefined {
      if (!this.batches.results) return undefined;
      return this.batches.results.find((batch: Batch) => String(batch.batch_pk) === String(this.$route.params.id));
    },
  },

  mounted() {
    this.fetchBatches({ page: 1, search: '' });
  },

  methods: {
    ...mapActions(['fetchBatches']),
  },
});
</script>

<style scoped>
:deep(.library-table) {
  @apply rounded-8 border border-gray-100;
}

:deep(.table-title) {
  @apply pl-24;
}
</style>
